/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const answerSchema = z.enum(['yes', 'no', 'skip']);

export type AnswerType = z.infer<typeof answerSchema>;
